import Vue from 'vue';
import App from './App.vue';
import router from './router';
import qs from 'qs';
import i18n from './i18n/i18n'
import wx from 'weixin-js-sdk';
import animated from 'animate.css';
import 'aos/dist/aos.css'
import AOS from 'aos/dist/aos.js'
import '@vant/touch-emulator';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import MetaInfo from 'vue-meta-info';
import waterfall from 'vue-waterfall2';
//import html2canvas from 'html2canvas';


import { navList } from '@/api/public';
// import { resourcesList } from '@/api/public_h5';

//import "lib-flexible/flexible";       // 自适配
import FastClick from 'fastclick';    // 移动端30ms延迟

import { Toast } from 'vant';
import { Loading } from 'vant';
import { Image as VanImage } from 'vant';
import { Empty } from 'vant';
import { List } from 'vant';
import { Icon } from 'vant';
import { Overlay } from 'vant';
import { Button } from 'vant';
import { Field } from 'vant';
import { Divider } from 'vant';
import { Popup } from 'vant';
import { Swipe, SwipeItem } from 'vant';
import { Search } from 'vant';
import { Lazyload } from 'vant';
import { Pagination } from 'vant';
import { Collapse, CollapseItem } from 'vant';
import { Sticky } from 'vant';
import { RadioGroup, Radio } from 'vant';
import { Checkbox, CheckboxGroup } from 'vant';

Vue.use(Toast);
Vue.use(Loading);
Vue.use(VanImage);
Vue.use(Empty);
Vue.use(List);
Vue.use(Icon);
Vue.use(Overlay);
Vue.use(Button);
Vue.use(Field);
Vue.use(Divider);
Vue.use(Popup);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Search);
Vue.use(Lazyload);
Vue.use(Pagination);
Vue.use(Sticky);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);

Vue.use(animated);
//初始化aos动画
Vue.use(AOS);
AOS.init({
	offset: 100,  //260  100
	easing: 'fade-up',
	duration: 1000,
	aosOnce: true,
	//disable: 'mobile',
});

Vue.use(ElementUI);
Vue.use(MetaInfo);
Vue.use(waterfall);

// moment.locale('zh-cn');
// moment.locale('cn');;


import axios from 'axios'
axios.defaults.withCredentials = true;
Vue.prototype.axios = axios;
Vue.prototype.wx = wx;

Vue.config.productionTip = false;

FastClick.attach(document.body);

FastClick.prototype.focus = function (targetElement) {
	let length;
	if(targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
		length = targetElement.value.length;
		targetElement.focus();
		targetElement.setSelectionRange(length, length);
	}else {
		targetElement.focus();
	}
};

router.beforeEach((to, from, next) => {
	//设置默认语言
	if(!sessionStorage.getItem('lang')){
		sessionStorage.setItem('lang', 'cn');
	}
	if(!sessionStorage.getItem('navList')) {
		navList({language: 'cn'}).then(res => {
			if(res.data.length > 0) {
				sessionStorage.setItem('navList', JSON.stringify(res.data));
				next();
			}
		});
	}else {
		next();
	}
});

new Vue({
  router,
  render: h => h(App),
  i18n,
}).$mount('#app')
